import { TemplateConfig } from '@rxweb/grid';
import { PipeConstants } from 'src/app/components/shared/constant/commonConstants';


export const PUBLIC_RFP_ACTION_GRID_TEMPLATE: TemplateConfig = {
    div: {
        class: 'formAction list-unstyled mb-0'.split(' '),
        childrens: [{
            a: {
                class:'gridEditbtn urlLinkClass'.split(' '),
                // authorize: 'put',
                event: {
                    click: 'onPublicRFP'
                },
                childrens: [{
                    a: {
                        childrens: [{
                            i: { class: 'feather icon-external-link'.split(' ') }
                        }],
                    }
                }]
            }
        },
        
        ]
    }
};
